import { z } from 'zod';

import { optionalString } from '@utils/validation';

export const dataConstants = {
	SSN: 'ssn',
};

export const testContent = {
	page_header: 'Do you have a social security number?',
	page_description:
		'<p>Our pharmacy uses SSN as a unique identifier to check the frequency of your testosterone refills, because testosterone is classified as a controlled substance. Folx does not use your SSN for any other purpose.</p>',
	yes_answer_label: 'Yes',
	no_answer_label: 'No',
};

export const schema = z.object({
	[dataConstants.SSN]: optionalString,
});
